var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64565 21.4616C1.95505 21.4616 0.40625 19.9391 0.40625 17.2616V4.42534C0.40625 1.74784 2.03375 0.225342 4.64565 0.225342H19.0438C21.7345 0.225342 23.1912 1.74784 23.1912 4.42534V17.2616C23.1912 19.9391 21.6425 21.4616 18.965 21.4616H4.64565ZM24.7269 14.7022V6.95854L29.465 2.98164C29.9244 2.60104 30.41 2.35164 30.8956 2.35164C31.8144 2.35164 32.4181 3.02104 32.4181 4.04474V17.6422C32.4181 18.666 31.8144 19.3353 30.8956 19.3353C30.41 19.3353 29.9244 19.086 29.465 18.7053L24.7269 14.7022Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/CameraOn.48d9ef3f624cff154e3da03e281d9d95.svg";
export { ForwardRef as ReactComponent };